<template>
  <div>
    <figure
      ref="imageouter"
      class="image__wrapper m-auto"
      :style="{'height': height + 'px'}">
      <img
        ref="image"
        :src="content.sizes.medium"
        :data-mbl-url="content.sizes.medium_large"
        :data-url="content.sizes.large"
        :alt="content.alt"
        :class="{ left: isLeft, right: isRight, }">
      <small
        v-if="content.caption"
        class="caption">
        {{ content.caption }}
      </small>
    </figure>
  </div>
</template>

<script>
export default {
  name: 'ImageBlock',
  props: {
    content: {
      type: Object,
      default: null
    },
    isLeft: {
      type: Boolean,
      default: false
    },
    isRight: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      ratio: (this.content.width / this.content.height).toFixed(2),
      windowHeight: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
      height: window.innerHeight * 0.8,
      observer: null
    }
  },
  computed: {
    imageWidth: function() {
      return this.windowHeight * 0.8 * this.ratio
    }
  },
  mounted() {
    // set image dimensions
    this.$refs.image.height = this.height
    this.$refs.image.width = this.imageWidth

    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver((entries, observer) => {
        if (entries[0].isIntersecting) {
          // load in full size image when image in view
          if(window.innerWidth > 768) {
            this.$refs.image.setAttribute('src', this.$refs.image.getAttribute('data-url'))
          } else {
            this.$refs.image.setAttribute('src', this.$refs.image.getAttribute('data-mbl-url'))
          }

          // remove image outer dimensions
          this.$refs.imageouter.style.height = 'auto'

          // wait for full size image load, show and set auto dimensions
          this.$refs.image.onload = function() {
            this.style.opacity = 1
            this.style.width = 'auto'
            this.style.height = 'auto'
          };
        }
      }, {
        root: null,
        threshold: 0
      })
      this.observer.observe(this.$refs.image)
    } else {
      // load in full size image when image in view
      if(window.innerWidth > 768) {
        this.$refs.image.setAttribute('src', this.$refs.image.getAttribute('data-url'))
      } else {
        this.$refs.image.setAttribute('src', this.$refs.image.getAttribute('data-mbl-url'))
      }

       // remove image outer dimensions
      this.$refs.imageouter.style.height = 'auto'

      // show image and set dimensions
      this.$refs.image.style.opacity = 1
      this.$refs.image.style.width = 'auto'
      this.$refs.image.style.height = 'auto'
    }
  }
}
</script>

<style lang="scss" scoped>
.image__wrapper {
  position: relative;

  img {
    opacity: 0;
    transition:opacity 250ms ease-in-out;
    margin: 0 auto;
    display: block;

    &.left {
      margin-left: 0;
    }

    &.right {
      margin-right: 0;
    }
  }

  .caption {
    display: block;
    font-size: 0.85rem;
    line-height: 1.1rem;
    font-weight: bold;
    margin-top: calc(#{$gutter--base-mbl} / 2);
    text-align: center;
  }
}
</style>
